<template>
  <el-dialog
    title="提示"
    :visible.sync="formDialogVisible"
    width="900px"
    :before-close="handleClose"
  >
    <el-input
      v-model="code"
      placeholder="请输入硬件编号"
      style="width: 210px; display: inline-block; margin-left: 10px"
      clearable
    ></el-input>
    <el-button type="primary" style="margin-left: 16px" @click="initTableData()"
      >搜索</el-button
    >
    <el-table
      :data="tableData"
      ref="singleTable"
      highlight-current-row
      @current-change="handleCurrentChange"
      height="300px"
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" align="center">
      </el-table-column>
      <el-table-column prop="serviceTypeName" label="服务类型" align="center">
      </el-table-column>
      <el-table-column prop="code" label="硬件编号" align="center">
      </el-table-column>
      <!-- <el-table-column
                    prop="frame_num"
                    label="车架号"
                    align="center"
                    >
                  </el-table-column> -->
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitHandel">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getAllHardwareList } from '@/api/hardware';
export default {
  props: {
    serviceTypeId: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    preHardwareCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      code: '',
      formDialogVisible: false,
      param: {},
      tableData: [],
      hardwareCode: '',
    };
  },
  watch: {
    // 显示隐藏双向绑定
    visible(val) {
      this.formDialogVisible = val;
      if (val) {
        this.initTableData();
      }
    },
    formDialogVisible(val) {
      this.$emit('visible-change', val);
    },
  },
  methods: {
    handleClose() {
      this.formDialogVisible = false;
      this.hardwareCode = ''; //重置
    },
    submitHandel() {
      this.$emit('success', this.hardwareCode);
      this.handleClose();
    },
    initTableData() {
      const param = {
        serviceTypeId: this.serviceTypeId,
        code: this.code,
        filterUsed: true,
      };
      getAllHardwareList(param).then((res) => {
        this.tableData = res.data;
        if (this.preHardwareCode) {
          const currentRow = res.data.find(
            (item) => item.code === this.preHardwareCode
          );
          this.$refs.singleTable.setCurrentRow(currentRow);
        }
      });
    },
    handleCurrentChange(val) {
      if (val) {
        this.hardwareCode = val.code;
      }
    },
  },
};
</script>

<style></style>
